/* NB-018-AB */
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.taste-texture-showdown--var-1');
  if (!root) return;

  const taskId = 'NB-018-AB';

  const track = (eventName, payload) => {
    const detail = Object.assign({ event: eventName, task_id: taskId }, payload || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
    document.dispatchEvent(new CustomEvent(eventName, { detail }));
  };

  const mediaNodes = root.querySelectorAll('[data-showdown-media]');
  if ('IntersectionObserver' in window) {
    const viewed = new WeakSet();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || viewed.has(entry.target)) return;
          viewed.add(entry.target);
          track('nb018_showdown_media_view', {
            media_key: entry.target.getAttribute('data-showdown-media'),
            media_type: entry.target.getAttribute('data-showdown-type')
          });
        });
      },
      { threshold: 0.5 }
    );
    mediaNodes.forEach((node) => observer.observe(node));
    mediaNodes.forEach((node) => {
      if (node.getAttribute('data-showdown-type') !== 'video') return;
      const video = node.matches('video') ? node : node.querySelector('video');
      if (!video) return;
      const play = () => {
        const playback = video.play();
        if (playback && typeof playback.catch === 'function') playback.catch(() => {});
      };
      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) play();
            else video.pause();
          });
        },
        { threshold: 0.25 }
      );
      videoObserver.observe(node);
    });
  }

  mediaNodes.forEach((node) => {
    node.addEventListener('click', () => {
      track('nb018_showdown_media_click', {
        media_key: node.getAttribute('data-showdown-media'),
        media_type: node.getAttribute('data-showdown-type')
      });
    });
  });

  const cta = root.querySelector('[data-showdown-cta]');
  if (cta) {
    cta.addEventListener('click', (event) => {
      const targetId = cta.getAttribute('data-showdown-scroll-target');
      track('nb018_showdown_cta_click', { target_id: targetId });

      if (!targetId) return;
      const target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.pushState(null, '', `#${targetId}`);
    });
  }
});
